import { Header } from 'semantic-ui-react';
import ReactGA from 'react-ga4';

import { useProjectTeamQuery } from '~/requests/team';
import TeamManagementTable from './TeamManagementTable';
import ExternalUserInvite from './ExternalUserInvite';
import { usePageType, useProjectContext, usePortfolioContext } from '~/hooks';
import { usePermissions } from '~/requests/permissions/usePermissions';
import { Loader } from 'semantic-ui-react';

const TeamManagement = () => {
  const { status } = useProjectTeamQuery();
  const pageType = usePageType();
  const { project } = useProjectContext();
  const { portfolio } = usePortfolioContext();
  const { permissions } = usePermissions();
  const label = pageType === 'project' && !project?.portfolioId ? 'project' : 'portfolio';

  if (portfolio) {
    ReactGA.send({
      hitType: 'pageview',
      page: '/portfolio/id/team',
      title: `${portfolio?.name} | Conductor Solar`
    });
    document.title = `${portfolio?.name} | Conductor Solar`;
  } else {
    ReactGA.send({
      hitType: 'pageview',
      page: '/project/id/team',
      title: `${project?.name} | Conductor Solar`
    });
    document.title = `${project?.name} | Conductor Solar`;
  }


  if (status === 'loading') {
    return (
      <div style={{ height: 'calc(100vh - 12rem)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Loader active size="large" />
      </div>
    );
  }

  return (
    <div style={{ paddingBottom: 'var(--x-large)' }}>
      <Header as="h2">Manage {label} team</Header>
      <p>Use the table below to add and remove individuals from your {label} team and to define their {label} role.</p>
      <TeamManagementTable />
      {permissions.canAddOrRemoveTeamMember && !permissions.isAdmin && <ExternalUserInvite />}
    </div>
  );
};

export default TeamManagement;